<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 id="modal-title"><b>{{'projects.' + projectData.name + '.title' | translate }}</b></h1>
        <!-- ajouter croix pour fermer (pas urgent) -->
    </header>
    <section id="modal-body" fxLayout="row wrap" fxLayoutAlign="center start" fxLayoutGap="20px grid">
        <div fxFlex="100%" fxFlex.gt-md="60%">
                <mdb-carousel class="carousel slide carousel-fade" [animation]="'fade'" [interval]="'0'">
                        <mdb-carousel-item class="img-fluid" *ngFor="let video of projectData.videos; let i = index">
                                    <div class="view">
                                    <!--Video source-->
                                        <video class="video-fluid" controls autoplay [muted]="'muted'">
                                            <source src="assets/images/projects/{{projectData.name}}/trailer.mp4" type="video/mp4" />
                                        </video>
                                    </div>
                        </mdb-carousel-item>
                        <mdb-carousel-item class="img-fluid" *ngFor="let img of projectData.images; let i = index">
                            <div class="view w-100">
                                <img class="d-block w-100" src="assets/images/projects/{{projectData.name}}/{{i}}.png">
                                <div class="mask waves-light" mdbWavesEffect></div>
                            </div>
                        </mdb-carousel-item>
                </mdb-carousel>
        </div>
        <div fxFlex="100%" fxFlex.gt-md="40%">
                <!--Text-->
                <!-- synopsis -->
            <div [innerHTML]="'projects.' + projectData.name + '.synopsis' | translate"></div>

            <!-- Role and description -->
            <h4>{{'projects.' + projectData.name + '.role' | translate }}</h4>
            <div [innerHTML]="'projects.' + projectData.name + '.description' | translate"></div>

            <!-- Team -->
            <div *ngIf="'projects.' + projectData.name + '.team' | translate">
                <h3 style="display: inline">{{'projects.team' | translate }} </h3>
                <div style="display: inline">{{'projects.' + projectData.name + '.team' | translate }}
                </div>
            </div>

            <!-- Links -->
            <h3>{{'projects.links' | translate }}</h3>
            <div flxLayout="row" fxLayoutAlign="space-around center" style="color:rgb(199, 167, 128);">
                <div *ngFor="let link of projectData.links; let i = index">
                    <div *ngIf="link.favicon" style="font-size:50px">
                        <a href={{link.href}}><i class="project-link {{link.favicon}}"></i></a>
                    </div>
                    <div *ngIf="link.image" style="font-size:40px;">
                        <a href="{{link.href}}"><img src="{{link.image}}" class="project-link"
                                style="width: 1.5em;"></a>
                    </div>
                </div>
        </div>
    </div>
    </section>
    <footer id="modal-footer">
    </footer>
</div>